<template>
  <ui-content title="Inicio">
    <ui-spinner v-if="loadingView"></ui-spinner>
    <template v-else>
      <div class="row">
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <Tile :amount="resumen.ordenes" title="Órdenes de Servicio" icon="fa fa-rocket"></Tile>
        </div>
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <Tile :amount="resumen.pax" title="Pasajeros" variant="info" icon="fa fa-users"></Tile>
        </div>
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <Tile :amount="resumen.espanol" title="Español" variant="warning" icon="fa fa-language"></Tile>
        </div>
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <Tile :amount="resumen.ingles" title="Inglés" variant="success" icon="fa fa-language"></Tile>
        </div>
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <Tile :amount="resumen.bibliaregistro" title="Registros de Biblia" variant="primary" icon="fa fa-book"></Tile>
        </div>
      </div>
      <ui-card title="Ordenes de Servicio del Día">
        <div v-if="!ordenesDia.length" class="alert alert-secondary">
          <i class="fa fa-fw fa-info-circle"></i>
          <span>No hay registros para mostrar</span>
        </div>
        <div v-else class="table-responsive">
          <table class="table table-bordered table-sm">
            <thead class="table-secondary">
              <tr class="text-center">
                <th></th>
                <th>Cód.</th>
                <th>Servicio</th>
                <th>Hora Salida</th>
                <th>Idioma</th>
                <th>Registros</th>
                <th>PAX</th>
                <th>CHD</th>
                <th>Vehículo</th>
                <th>Guía</th>
                <th>Asistente</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in ordenesDia" :key="item.idOrden" class="text-center align-middle">
                <td style="width: 40px">
                  <router-link
                    class="btn btn-icon btn-xs btn-light-primary"
                    :to="{
                      name: 'ordenes.registros',
                      params: { idOrden: item.idOrden },
                    }"
                  >
                    <span class="fa fa-fw fa-eye"></span>
                  </router-link>
                </td>
                <td>{{ item.codigo }}</td>
                <td>{{ item.servicio }}</td>
                <td>{{ $formatter("time", item.horaSalida) }}</td>
                <td>{{ item.idioma }}</td>
                <td>{{ item.registros }}</td>
                <td>{{ item.nroAdultos }}</td>
                <td>{{ item.nroNinos }}</td>
                <td>{{ item.vehiculo }}</td>
                <td>{{ item.guia }}</td>
                <td>{{ item.asistente }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </ui-card>
      <!-- Privados -->
      <ui-card title="Servicios Privados del Día">
        <div v-if="!privadosDia.length" class="alert alert-secondary">
          <i class="fa fa-fw fa-info-circle"></i>
          <span>No hay registros para mostrar</span>
        </div>
        <b-table v-else head-variant="light" bordered small hover responsive :fields="tableFieldsPrivadosDia" :items="privadosDia">
          <template v-slot:cell(link)="{ item: { codigo } }">
            <router-link
              class="btn btn-icon btn-xs btn-light-primary"
              :to="{
                name: 'privados',
                query: { codigo },
              }"
            >
              <span class="fa fa-fw fa-eye"></span>
            </router-link>
          </template>
          <template v-slot:cell(fechaLlegada)="{ item: { fechaLlegada } }">{{ $formatter("date", fechaLlegada) }}</template>
          <template v-slot:cell(fechaSalida)="{ item: { fechaSalida } }">{{ $formatter("date", fechaSalida) }}</template>
        </b-table>
      </ui-card>
      <!-- Itinerarios -->
      <ui-card title="Itinerarios del Día">
        <div v-if="!itinerariosDia.length" class="alert alert-secondary">
          <i class="fa fa-fw fa-info-circle"></i>
          <span>No hay registros para mostrar</span>
        </div>
        <!-- TODO: cambiar a componente local Table -->
        <BTable v-else head-variant="light" bordered small hover responsive :fields="tableFieldsItinerariosDia" :items="itinerariosDia">
          <template v-slot:cell(link)>
            <router-link
              class="btn btn-icon btn-xs btn-light-primary"
              :to="{
                name: 'itinerarios.privados',
              }"
            >
              <span class="fa fa-fw fa-eye"></span>
            </router-link>
          </template>

          <template v-slot:cell(hora)="{ item: { hora } }">{{ $formatter("time", hora) }}</template>
        </BTable>
      </ui-card>
      <!-- Endoses -->
      <ui-card title="Endoses del Día">
        <div v-if="!endosesDia.length" class="alert alert-secondary">
          <i class="fa fa-fw fa-info-circle"></i>
          <span>No hay registros para mostrar</span>
        </div>
        <b-table v-else head-variant="light" bordered small hover responsive :fields="tableFieldsEndosesDia" :items="endosesDia">
          <template v-slot:cell(link)>
            <router-link
              class="btn btn-icon btn-xs btn-light-primary"
              :to="{
                name: 'endosados',
                query: { fecha: fechaHoy },
              }"
            >
              <span class="fa fa-fw fa-eye"></span>
            </router-link>
          </template>
          <template v-slot:cell(fecha)="{ item: { fecha } }">{{ $formatter("date", fecha) }}</template>
          <template v-slot:cell(horaInicioRecojo)="{ item: { horaInicio, horaRecojo } }">
            <div v-if="horaRecojo">
              R:
              {{ horaRecojo ? $formatter("time", horaRecojo) : "" }}
            </div>
            <div v-if="horaInicio">
              I:
              {{ horaInicio ? $formatter("time", horaInicio) : "" }}
            </div>
          </template>

          <template v-slot:cell(trenInOut)="{ item: { trenIn, trenOut } }">
            <div v-if="(trenIn || '').trim()">I: {{ trenIn }}</div>
            <div v-if="(trenOut || '').trim()">O: {{ trenOut }}</div>
          </template>
          <template v-slot:cell(vehiculoConductor)="{ item: { vehiculo, conductor } }">
            <div v-if="vehiculo">{{ vehiculo }}</div>
            <div v-if="conductor">{{ conductor }}</div>
          </template>
        </b-table>
      </ui-card>
      <!-- Seccion desactivada temporalmente: biblias sin servicio.
      <ui-card title="Biblias sin servicio">
        <div v-if="!bibliasSinServicio.length" class="alert alert-secondary">
          <i class="fa fa-fw fa-info-circle"></i>
          <span>No hay registros para mostrar</span>
        </div>
        <b-table v-else head-variant="light" bordered small hover responsive :fields="tableFieldsBibliasSinServicio" :items="bibliasSinServicio">
          <template v-slot:cell(link)="{ item: { idBiblia } }">
            <router-link
              :to="{
                name: 'biblias.registros',
                query: { id: idBiblia },
              }"
              class="btn btn-xs btn-icon btn-light-primary"
            >
              <span class="fa fa-fw fa-eye"></span>
            </router-link>
          </template>
          <template v-slot:cell(fecha)="{ item: { fecha } }">{{ $formatter("date", fecha) }}</template>
        </b-table>
      </ui-card>
      -->
    </template>
  </ui-content>
</template>
<script>
import Tile from "../modules/shared/components/Tile.vue";
const UiWidgetStats = () => import(/* webpackChunkName: "ui-widget-stats" */ "@/components/layout/UiWidgetStats");
import { BTable } from "bootstrap-vue";

export default {
  components: {
    UiWidgetStats,
    BTable,
    Tile,
  },
  data() {
    return {
      // containers
      // bibliasSinServicio: null,
      ordenesDia: null,
      privadosDia: [],
      itinerariosDia: [],
      endosesDia: [],
      resumen: null,
      tableFieldsPrivadosDia: [
        {
          key: "link",
          label: "",
          tdClass: "actions-1",
        },
        {
          key: "codigo",
          label: "Cód.",
        },
        {
          key: "agencia",
          label: "Agencia",
        },
        {
          key: "docVenta",
          label: "Doc. Venta",
        },
        {
          key: "fechaLlegada",
        },
        {
          key: "fechaSalida",
        },
        {
          key: "guia",
          label: "Guía",
        },
        {
          key: "idioma",
        },
        {
          key: "nroAdultos",
          label: "PAX",
        },
        {
          key: "nroNinos",
          label: "CHD",
        },
        {
          key: "nroDocVenta",
          label: "Nro. Doc. Venta",
        },
        {
          key: "pasajero",
        },
      ],
      tableFieldsItinerariosDia: [
        {
          key: "link",
          label: "",
          tdClass: "actions-1",
        },
        {
          key: "hora",
        },
        {
          key: "codigo",
          label: "Cód.",
        },
        {
          key: "servicio",
        },
        {
          key: "servicioTipo",
          label: "Tipo",
        },
        {
          key: "pasajero",
        },
        {
          key: "nroAdultos",
          label: "PAX",
        },
        {
          key: "nroNinos",
          label: "CHD",
        },
        {
          key: "hotel",
        },
        {
          key: "agencia",
        },
        {
          key: "vueloTourTren",
          label: "Vuelo / Tour / Tren",
        },
        {
          key: "identificador",
          label: "Móvil",
        },
        {
          key: "guia",
          label: "Guía",
        },
        {
          key: "transfer",
        },
        {
          key: "abreviatura",
          label: "Idioma",
        },
        {
          key: "observaciones",
          label: "Obs.",
        },
      ],
      /* tableFieldsBibliasSinServicio: [
        {
          key: "link",
          label: "",
          tdClass: "actions-1",
        },
        {
          key: "codigo",
          label: "Cód.",
          tdClass: "text-nowrap",
        },
        {
          key: "fecha",
          tdClass: "text-nowrap",
        },
        {
          key: "servicio",
        },
        {
          key: "agencia",
        },
        {
          key: "codigoAgencia",
          label: "File",
        },
        {
          key: "nombre",
        },
        {
          key: "tipo",
        },
        {
          key: "nroAdultos",
          label: "PAX",
        },
        {
          key: "nroNinos",
          label: "CHD",
        },
        {
          key: "idioma",
        },
        {
          key: "hotel",
        },
        {
          key: "estado",
        },
      ], */
      fechaHoy: this.$dayjs().format("YYYY-MM-DD"),
      // loaders
      loadingView: true,
    };
  },
  computed: {
    tableFieldsEndosesDia() {
      const vm = this;

      let fields = [
        {
          key: "link",
          label: "",
          tdClass: "actions-1",
        },
        {
          key: "codigo",
          label: "Cód.",
          tdClass: "text-nowrap",
        },
        {
          key: "fecha",
          tdClass: "text-nowrap",
        },
        {
          key: "horaRecojo",
        },
        {
          key: "horaInicio",
        },
        {
          key: "horaInicioRecojo",
          label: "Hora Inicio / Recojo",
        },
        {
          key: "servicio",
        },
        {
          key: "pasajero",
        },
        {
          key: "nroAdultos",
          label: "PAX",
        },
        {
          key: "nroNinos",
          label: "CHD",
        },
        {
          key: "hotel",
        },
        {
          key: "agencia",
        },
        {
          key: "trenIn",
        },
        {
          key: "trenOut",
        },
        {
          key: "trenInOut",
          label: "Tren In / Out",
        },
        {
          key: "vehiculo",
        },
        {
          key: "conductor",
        },
        {
          key: "vehiculoConductor",
          label: "Vehículo / Conductor",
        },
        {
          key: "guia",
          label: "Guía",
        },
        {
          key: "transfer",
        },
        {
          key: "idioma",
        },
        {
          key: "observaciones",
        },
        {
          key: "file",
          tdClass: "text-nowrap",
        },
        {
          key: "servicioTipo",
          label: "Tipo",
        },
        {
          key: "horaTicket",
        },
        {
          key: "restaurante",
        },
        {
          key: "hotelOvernight",
        },
        {
          key: "horaHuayna",
          label: "Hora Huayna Picchu",
        },
        {
          key: "origen",
        },
        {
          key: "destino",
        },
      ];

      let keys = Object.keys(vm.endosesDia[0] ?? {});
      keys = [...keys, "link", "horaInicioRecojo", "vehiculoConductor", "trenInOut"];

      let fieldsFilter = fields.filter((item) => keys.includes(item.key));

      if (vm.$findItemByObjectProperty(fieldsFilter, "key", "horaRecojo") || vm.$findItemByObjectProperty(fieldsFilter, "key", "horaInicio")) {
        fieldsFilter = vm.$removeItemByObjectProperty(fieldsFilter, "key", ["horaRecojo", "horaInicio"]);
      } else {
        fieldsFilter = vm.$removeItemByObjectProperty(fieldsFilter, "key", "horaInicioRecojo");
      }

      if (vm.$findItemByObjectProperty(fieldsFilter, "key", "vehiculo") || vm.$findItemByObjectProperty(fieldsFilter, "key", "conductor")) {
        fieldsFilter = vm.$removeItemByObjectProperty(fieldsFilter, "key", ["vehiculo", "conductor"]);
      } else {
        fieldsFilter = vm.$removeItemByObjectProperty(fieldsFilter, "key", "vehiculoConductor");
      }

      if (vm.$findItemByObjectProperty(fieldsFilter, "key", "trenIn") || vm.$findItemByObjectProperty(fieldsFilter, "key", "trenOut")) {
        fieldsFilter = vm.$removeItemByObjectProperty(fieldsFilter, "key", ["trenIn", "trenOut"]);
      } else {
        fieldsFilter = vm.$removeItemByObjectProperty(fieldsFilter, "key", "trenInOut");
      }

      return fieldsFilter;
    },
  },
  async created() {
    let vm = this;
    let response = await vm.axios.get("/inicio");
    let { ordenesDia, resumen, privadosDia, itinerariosDia, endosesDia } = response.data.content;

    // let { bibliasSinServicio } = response.data.content;
    // vm.bibliasSinServicio = bibliasSinServicio;
    vm.ordenesDia = ordenesDia;
    vm.privadosDia = privadosDia;
    vm.itinerariosDia = itinerariosDia;
    vm.endosesDia = vm.$removeEmptyColumns(endosesDia);
    vm.resumen = resumen;

    vm.loadingView = false;
  },
};
</script>
